import React from 'react';
import {
  ResponsiveContainer,
  ComposedChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Bar,
  Tooltip,
  Cell
} from 'recharts';
import { DIFFICULTY_COLORS } from '../utils/constants';

// 디자인 토큰 import
import { HEX_COLORS } from '../../../styles/tokens';

const DifficultyAccuracyChartSection = React.memo(({
  selectedTest,
  getLevelAchievementData,
  getYAxisLabelColor
}) => {
  if (!selectedTest) return null;

  const chartData = getLevelAchievementData(selectedTest);

  return (
    <div className="col-span-1 rounded-3xl bg-gray-50 p-3">
      <h4 className="mb-2 text-xs font-medium text-gray-700">난이도별 정답률</h4>
      <div className="flex h-32 items-center justify-center">
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart
            data={chartData}
            margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
            isAnimationActive={false}
          >
            <CartesianGrid strokeDasharray="3 3" stroke={HEX_COLORS.lightGray} />
            <XAxis
              dataKey="level"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 10, fill: HEX_COLORS.gray600 }}
              tickFormatter={(value) => `Lv${value}`}
              height={20}
              padding={{ left: 0, right: 0 }}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              domain={[0, 100]}
              ticks={[0, 25, 50, 75, 100]}
              tick={(props) => {
                const { x, y, payload } = props;
                const value = payload.value;
                const color = getYAxisLabelColor(value, false); // 정답률 Y축

                return (
                  <text
                    x={x}
                    y={y}
                    textAnchor="end"
                    fontSize={7}
                    fill={color}
                    fontWeight="bolder"
                    dx={-2}
                  >
                    {value}
                  </text>
                );
              }}
              width={15}
              tickMargin={-5}
            />
            <Tooltip
              isAnimationActive={false}
              contentStyle={{
                fontSize: '10px',
                padding: '4px 6px',
                borderRadius: '4px',
                border: `1px solid ${HEX_COLORS.borderGray}`,
                backgroundColor: 'white'
              }}
              formatter={(value, name, props) => {
                const correct = props.payload.currentCorrect;
                const total = props.payload.currentTotal;
                return [
                  `${value}% (${correct}/${total})`,
                  '정답률'
                ];
              }}
              labelFormatter={(label) => `Lv${label}`}
            />
            <Bar
              dataKey="currentAcc"
              radius={[8, 8, 0, 0]}
              isAnimationActive={false}
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={DIFFICULTY_COLORS[index]} isAnimationActive={false} />
              ))}
            </Bar>
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
});

export default DifficultyAccuracyChartSection;
